import { render, staticRenderFns } from "./RelatoriosExtenso.vue?vue&type=template&id=3c88ef40&"
import script from "./RelatoriosExtenso.vue?vue&type=script&lang=js&"
export * from "./RelatoriosExtenso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports